import React from "react";
import { Reveal } from "@/components/Reveal";
import { REVIEWS } from "@/data/content";

export const Reviews = () => {
  return (
    <section id="reviews" className="py-28 md:py-40 bg-warmwhite" data-testid="reviews-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-24">
          <Reveal>
            <p className="overline text-champagne mb-6">In Their Words</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.08] text-charcoal">
              Trusted inside the finest homes.
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-6">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.12}>
              <div className="border border-stone/70 p-10 h-full flex flex-col justify-between bg-warmwhite hover:border-champagne transition-colors duration-500" data-testid={`review-${i}`}>
                <div className="flex gap-1 mb-8">
                  {[...Array(5)].map((_, s) => (
                    <span key={s} className="text-champagne text-sm">★</span>
                  ))}
                </div>
                <p className="font-serif text-xl md:text-2xl leading-snug text-charcoal font-light">{r.quote}</p>
                <div className="mt-10 pt-6 border-t border-stone/60">
                  <p className="text-charcoal font-semibold text-sm">{r.name}</p>
                  <p className="text-charcoal/50 text-sm mt-1">{r.location}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
